import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "gene-color-view-container" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Exploration", -1)
const _hoisted_4 = { class: "select-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " R Genes/Features ", -1)
const _hoisted_6 = { class: "switch-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "switch-label" }, "Log", -1)
const _hoisted_8 = { class: "select-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " G Genes/Features ", -1)
const _hoisted_10 = { class: "switch-container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "switch-label" }, "Log", -1)
const _hoisted_12 = { class: "select-container" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " B Genes/Features ", -1)
const _hoisted_14 = { class: "switch-container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "switch-label" }, "Log", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Style", -1)
const _hoisted_17 = { class: "select-container" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " Marker Size ", -1)
const _hoisted_19 = { class: "right-side" }
const _hoisted_20 = { class: "plot-container" }
const _hoisted_21 = { class: "confirm-analysis-button" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Analysis")
const _hoisted_23 = { class: "select-container" }
const _hoisted_24 = { class: "gene-list-container" }
const _hoisted_25 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_GeneColorViewPlot = _resolveComponent("GeneColorViewPlot")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_select_v2, {
          modelValue: _ctx.selectedGeneFeatureR,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGeneFeatureR) = $event)),
          class: "select",
          filterable: "",
          remote: "",
          "remote-method": _ctx.geneFeatureFilterR,
          options: _ctx.geneFeatureListR,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.geneFeatureChangeCallBack($event, 'R')))
        }, null, 8, ["modelValue", "remote-method", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.useLogR,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.useLogR) = $event)),
          disabled: !_ctx.logableR,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logChangeCallback($event, 'R')))
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_el_select_v2, {
          modelValue: _ctx.selectedGeneFeatureG,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedGeneFeatureG) = $event)),
          class: "select",
          filterable: "",
          remote: "",
          "remote-method": _ctx.geneFeatureFilterG,
          options: _ctx.geneFeatureListG,
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.geneFeatureChangeCallBack($event, 'G')))
        }, null, 8, ["modelValue", "remote-method", "options"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.useLogG,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.useLogG) = $event)),
          disabled: !_ctx.logableG,
          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.logChangeCallback($event, 'G')))
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_select_v2, {
          modelValue: _ctx.selectedGeneFeatureB,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedGeneFeatureB) = $event)),
          class: "select",
          filterable: "",
          remote: "",
          "remote-method": _ctx.geneFeatureFilterB,
          options: _ctx.geneFeatureListB,
          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.geneFeatureChangeCallBack($event, 'B')))
        }, null, 8, ["modelValue", "remote-method", "options"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.useLogB,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.useLogB) = $event)),
          disabled: !_ctx.logableB,
          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.logChangeCallback($event, 'B')))
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_15
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_el_select, {
          modelValue: _ctx.markerSize,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.markerSize) = $event)),
          class: "select",
          filterable: "",
          onChange: _ctx.markerSizeChangeCallback
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markerSizeList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: String(item),
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createVNode(_component_el_divider, {
      direction: "vertical",
      class: "mid-separator"
    }),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_GeneColorViewPlot, { ref: "colorPlot" }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_el_button, {
          size: "large",
          type: "primary",
          onClick: _ctx.analysisFromSelected
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.selectedGeneFeatureList,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedGeneFeatureList) = $event)),
          multiple: "",
          placeholder: "Select",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysisGeneList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.rank+'-'+item.id,
                label: item.rank+'-'+item.id,
                value: {label:item.rank+'-'+item.id, value:item.src}
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGeneFeatureList, (image) => {
          return (_openBlock(), _createElementBlock("div", {
            key: image.label
          }, [
            _createElementVNode("img", {
              src: image.value,
              class: "gene-container"
            }, null, 8, _hoisted_25)
          ]))
        }), 128))
      ])
    ])
  ]))
}